import { z } from 'zod';

export const AuraProfileCode = z.enum([
  'ADVISOR',
  'ANALYST',
  'ANIMATOR',
  'COACH',
  'PEACEMAKER',
  'PILOT',
  'PLANNER',
  'PROTECTOR',
]);

export type AuraProfileCodeT = z.infer<typeof AuraProfileCode>;
